// 9/30：SearchForm 在 search-form.js 里，只有原主题的 header.liquid 引了它，现在用的 yonghui 页头不引——
// 搜索页一打开就报「SearchForm is not defined」。照 predictive-search.js 的写法，没有就不注册（搜索框本身是普通表单，照常能搜）。
(function () {
  if (typeof SearchForm === 'undefined') {
    // 10-20 甲方第三批第 4 条「X 无法点击」：没有 SearchForm 时 × 是原生 type="reset"，
    // 原生 reset 只会把输入框恢复成页面带来的搜索词（defaultValue），看起来点了没反应。
    // 这里自己接管：清空输入框并聚焦，方便直接输入新的词。
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('main-search .reset__button');
      if (!btn || !btn.form) return;
      e.preventDefault();
      var input = btn.form.querySelector('input[type="search"]');
      if (input) { input.value = ''; input.focus(); }
    });
    return;
  }

  class MainSearch extends SearchForm {
    constructor() {
      super();
      this.allSearchInputs = document.querySelectorAll('input[type="search"]');
      this.setupEventListeners();
    }

    setupEventListeners() {
      let allSearchForms = [];
      this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      if (allSearchForms.length < 2) return;
      allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
      this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.keepInSync('', this.input);
      }
    }

    onInput(event) {
      const target = event.target;
      this.keepInSync(target.value, target);
    }

    onInputFocus() {
      const isSmallScreen = window.innerWidth < 750;
      if (isSmallScreen) {
        this.scrollIntoView({ behavior: 'smooth' });
      }
    }

    keepInSync(value, target) {
      this.allSearchInputs.forEach((input) => {
        if (input !== target) {
          input.value = value;
        }
      });
    }
  }

  customElements.define('main-search', MainSearch);
})();
